/* This is the default text for the application. Any key we added should be added here. This can be overridden using the contenful API and i18n namespacing feature. */

import global from '@/lang/keys/global.lang';
import styleguide from '@/lang/keys/styleguide.lang';

import {
  header,
  footer,
  register,
  login,
  contactUs,
  documents,
  multipleGroups,
  accounts,
  accountSettings,
  accountSettingsTools,
  submitClaim,
  personalInformation,
  releaseAuthorization,
  makeDeposit,
  investmentAccountTransfer,
  submitOnlineApplication,
  activateHSA,
  authToken,
  printScreen,
  validateAddress,
  validateEmail,
  pdf,
  xls,
} from '@/lang/keys/components';

export default {
  ...global,
  ...styleguide,
  ...header,
  ...footer,
  ...register,
  ...login,
  ...contactUs,
  ...accounts,
  ...accountSettings,
  ...accountSettingsTools,
  ...submitClaim,
  ...documents,
  ...multipleGroups,
  ...personalInformation,
  ...releaseAuthorization,
  ...makeDeposit,
  ...investmentAccountTransfer,
  ...submitOnlineApplication,
  ...activateHSA,
  ...authToken,
  ...printScreen,
  ...validateAddress,
  ...validateEmail,
  ...pdf,
  ...xls,
};
